const SELECTED_DAY_BACKGROUND_COLOR_CSS_VARIABLE = "--date-picker-selected-day-background-color";
const DAY_HOVER_BACKGROUND_COLOR_CSS_VARIABLE = "--date-picker-day-hover-background-color";
const WEEK_BETWEEN_GAP_CSS_VARIABLE = "--date-picker-week-between-gap";

export { DAY_HOVER_BACKGROUND_COLOR_CSS_VARIABLE, SELECTED_DAY_BACKGROUND_COLOR_CSS_VARIABLE, WEEK_BETWEEN_GAP_CSS_VARIABLE };
//# sourceMappingURL=styles.mjs.map
